import { MusicNote, MusicNoteName } from "../models/MusicNote.model";

// A. hardcode every note's relationships
// B. put the notes in a looping data structure, and let the program figure out the intervals
// B.1 Hashmap<NoteName, { nextNeighbor: NoteName, previousNeighbor: NoteName} >
// Pro: easy.  instant lookup for a given note
// Con: walking through 12 notes requires 12 lookups.
// Con:
// B.2: array of 12 strings
// Pro: simply increment (albeit with mod operator) to find intervals
// Pro: each scale can be represented with a subset of the interval positions (minors which vary up/down is confusing but w/e)
export function buildTwelveNoteScale(): Array<MusicNote> {
  return [
    {
      name: MusicNoteName.A,
    },
    {
      sharpName: MusicNoteName.Asharp,
      flatName: MusicNoteName.Bflat,
    },
    {
      name: MusicNoteName.B,
    },
    {
      name: MusicNoteName.C,
      sharpName: MusicNoteName.Bsharp,
    },
    {
      sharpName: MusicNoteName.Csharp,
      flatName: MusicNoteName.Dflat,
    },
    {
      name: MusicNoteName.D,
    },
    {
      sharpName: MusicNoteName.Dsharp,
      flatName: MusicNoteName.Eflat,
    },
    {
      name: MusicNoteName.E,
      flatName: MusicNoteName.Fflat,
    },
    {
      name: MusicNoteName.F,
      sharpName: MusicNoteName.Esharp,
    },
    {
      sharpName: MusicNoteName.Fsharp,
      flatName: MusicNoteName.Gflat,
    },
    {
      name: MusicNoteName.G,
    },
    {
      sharpName: MusicNoteName.Gsharp,
      flatName: MusicNoteName.Aflat,
    },
  ];
}
